module.exports = __webpack_public_path__ + "static/media/latestdevelopments3.9dbbfd8d.png";